import 'remodal';

window.REMODAL_GLOBALS = {
  NAMESPACE: 'modal',
  DEFAULTS: {
      hashTracking: false
  }
};

document.addEventListener('DOMContentLoaded', function () {
  var formGroups = document.querySelectorAll('.form__group input, .form__group textarea');

  formGroups.forEach(function (input) {
      input.addEventListener('focus', function () {
          input.parentNode.classList.add('active');
      });

      input.addEventListener('blur', function () {
          if (input.value.trim() === '') {
              input.parentNode.classList.remove('active');
          }
      });

      input.addEventListener('input', function () {
          var formGroup = input.parentNode;

          if (input.value.trim() !== '') {
              formGroup.classList.add('active');
          } else {
              formGroup.classList.remove('active');
          }
      });
  });
});